import React, { useEffect, useState } from "react";
import Base from "../utils/base";
import { useSearchParams } from 'react-router-dom';

import Header from './components/detail/Header'
import RoomInfo from './components/detail/RoomInfo'
import RoomGallery from './components/detail/RoomGallery'
import RoomDescription from './components/detail/RoomDescription'
import RoomInfo1 from './components/detail/RoomInfo1'

export default function RoomDetail(props) {
	var base = new Base();
	const [searchParams, setSearchParams] = useSearchParams();
	const [roomInfo, setRoomInfo] = useState({
		// name: 'Deluxe Room',
		// numPerson: 3,
		// numDuration: 3,
		// totalGuest: 100,
		// price: 150000,
		// totalReview: 3,
		// overview: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteradution in some form by injected humour, or randomised words which don't look even slightly believable. If you are going There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteradution in some form by injected humour",
		// arrImage: [
		// 	{
		// 		id: '',
		// 		image: '/assets/images/resources/room-slider-1-1.jpg',
		// 	},
		// 	{
		// 		id: '',
		// 		image: '/assets/images/resources/room-slider-1-2.jpg',
		// 	},
		// 	{
		// 		id: '',
		// 		image: '/assets/images/resources/room-slider-1-1.jpg',
		// 	},
		// 	{
		// 		id: '',
		// 		image: '/assets/images/resources/room-slider-1-2.jpg',
		// 	},
		// ],
	})

	useEffect(() => {
    get_data()
  }, [])

  async function get_data() {
    var response = await base.request(base.url_api + "/room?id=" + searchParams.get('id'))

    if(response != null){
      if(response.status == "success"){
				response.data.numPerson = 0
				response.data.numDuration = 0
				response.data.totalGuest = 0
				response.data.totalReview = 0
				response.data.overview = response.data.description

				for(let image of response.data.image){
					image.image = image.url_image
				}
				response.data.arrImage = response.data.image

				for(let testimony of response.data.testimony){
					testimony.createdDate = moment(testimony.created_at)
				}
        setRoomInfo(response.data)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

	return (
		<>
			{/* <Header/> */}
			{/* {
				roomInfo.id != null &&
				<>
					<RoomInfo roomInfo={roomInfo}/>
					<RoomGallery roomInfo={roomInfo}/>
					<RoomDescription roomInfo={roomInfo}/>
				</>
			} */}
			{
				roomInfo.id != null &&
				<>
					<RoomGallery roomInfo={roomInfo}/>
					<RoomInfo1 roomInfo={roomInfo}/>
				</>
			}
			
		</>
	);
};
